/* custom-product-ui.js — ricostruisce SOLO il prezzo nello sticky cart
   - Legge il prezzo dal blocco principale .product__price (senza modificarlo)
   - Estrae "compare" (barrato) e "final" (scontato)
   - Ricostruisce il markup dentro .product__sticky-cart--price
   - Si aggiorna su: cambio variante, aggiornamenti Zepto, mutazioni DOM del prezzo
   - (Opzionale) chiede il refresh del drawer dopo ATC se serve
*/

(() => {
  // --- Helpers -------------------------------------------------------------
  const throttle = (fn, wait = 120) => {
    let t, last = 0;
    return (...args) => {
      const now = Date.now();
      const remain = wait - (now - last);
      if (remain <= 0) { last = now; fn(...args); }
      else { clearTimeout(t); t = setTimeout(() => { last = Date.now(); fn(...args); }, remain); }
    };
  };

  // Estrai importi da testo (formato €1.234,56)
  const parsePrices = (txt) => {
    const euros = (txt || '').match(/€\s?[\d\.\,]+/g) || [];
    if (!euros.length) return { compare: null, final: null };
    if (euros.length === 1) return { compare: null, final: euros[0].trim() };
    // euristica robusta: prima occorrenza = compare, ultima = finale
    return { compare: euros[0].trim(), final: euros[euros.length - 1].trim() };
  };

  // Legge compare/final dal blocco prezzo "sopra" (senza modificarlo)
  const readMainPrice = (sectionRoot) => {
    const priceRoot = sectionRoot.querySelector('.product__price');
    if (!priceRoot) return { compare: null, final: null };

    // Candidati comuni per prezzo finale
    const finalEl =
      priceRoot.querySelector('.price-item--sale') ||
      priceRoot.querySelector('.price__sale .money') ||
      priceRoot.querySelector('.price .money:last-child') ||
      priceRoot.querySelector('.money');

    // Candidati comuni per compare barrato
    const compareEl =
      priceRoot.querySelector('del') ||
      priceRoot.querySelector('.price__compare') ||
      priceRoot.querySelector('.price-item--regular');

    const finalTxt = finalEl?.textContent?.trim();
    const compareTxt = compareEl?.textContent?.trim();

    if (finalTxt) return { compare: compareTxt || null, final: finalTxt };

    // Fallback: parsing dal testo completo
    return parsePrices(priceRoot.textContent);
  };

// Scrive SOLO il prezzo finale nello sticky (niente barrato)
const renderStickyPrice = (stickyEl, prices) => {
  if (!stickyEl || !prices) return;
  const { final } = prices;
   stickyEl.innerHTML = final ? `<strong>${final}</strong>` : '';
};


  // Copia e aggiorna sticky
  const updateStickyFromMain = (sectionRoot) => {
    const stickyEl = sectionRoot.querySelector('.product__sticky-cart--price');
    if (!stickyEl) return;
    const prices = readMainPrice(sectionRoot);
    renderStickyPrice(stickyEl, prices);
  };

  // --- Inizializza una sezione prodotto -----------------------------------
  const initSection = (sectionId) => {
    const sectionRoot = document.getElementById(`shopify-section-${sectionId}`);
    if (!sectionRoot) return;

    // 1) Primo sync
    updateStickyFromMain(sectionRoot);

    // 2) Osserva cambi del prezzo principale (Zepto, varianti, sconti)
    const mainPriceBlock = sectionRoot.querySelector('.product__price');
    if (mainPriceBlock) {
      const mo = new MutationObserver(throttle(() => updateStickyFromMain(sectionRoot), 80));
      mo.observe(mainPriceBlock, { childList: true, subtree: true, characterData: true });
    }

    // 3) Eventi utili
    window.addEventListener('zpp_price_updated', () => updateStickyFromMain(sectionRoot));
    document.addEventListener('variant:change', () => updateStickyFromMain(sectionRoot));

    // 4) (Opzionale) dopo ATC rinfresca il drawer
    const productForm = sectionRoot.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      document.addEventListener('ajaxProduct:added', () => {
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof window.refreshCart === 'function') window.refreshCart(true);
      });
      productForm.addEventListener('submit', () => {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof window.refreshCart === 'function') window.refreshCart(true);
        }, 800);
      });
    }
  };

  // --- Bootstrap -----------------------------------------------------------
  const boot = () => {
    document.querySelectorAll('product-form[data-section-id]').forEach(pf => {
      const sid = pf.getAttribute('data-section-id');
      if (sid) initSection(sid);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // In editor Shopify rinizializza quando ricarichi la sezione
  document.addEventListener('shopify:section:load', (ev) => {
    const sid = ev.target?.id?.replace('shopify-section-', '');
    if (sid) initSection(sid);
  });
})();
